<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
      <Card>
        <tables
          editable
          :columns="columns"
          v-model="tableData"
          :loading="tableLoading"
        />
      </Card>
    </Form>
  </div>
</template>

<script>
import Tables from '_c/tables/table-only.vue'
import params from '../argu-page/params.vue'
import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

export default {
  components: {
    params,
    Tables
  },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      upload_loadding: false,
      tableLoading: false,
      selectTableLoading: false,
      url_loadding: false,
      classifyIds: [],
      tagIds: [],
      audioModelIds: [],
      show_face_path: '',
      show_video_path: '',
      update_id: true,
      page: 1,
      pageSize: 20,
      total: 0,
      formValidate: {
      },
      ruleValidate: {
      },
      columns: [
        { type: 'index', title: '序号', width: 100, align: 'center' },
        { title: '描述', key: 'video_desc', editable: true, align: 'center' },
        { title: '分辨率', key: 'resolving_power', editable: true, align: 'center' },
        { title: '视频',
          key: 'url',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return params.row.url != '' ? h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.download(baseUrl == 'https://in.sinano-ai.com/api' ? params.row.id_url : params.row.url)
                    }
                  }
                },
                '查看'
              )
            ]) : h('span', '')
          }
        }
      ],
      tableData: []
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    download (url) {
      window.open(url, '_blank')
    },
    setEditData (params) {
      this.tableData = params.list
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
